// Constants
import {
  SUPPLIER_CATEGORIES,
  SUPPLIER_RISK_CLASSIFICATION,
  SUPPLIERS_MANAGE_PERSONAL_DATA,
} from '@/lib/constants/suppliers'
const PERSONAL_DATA_LABELS = {
  [SUPPLIERS_MANAGE_PERSONAL_DATA.NONE]: 'None',
  [SUPPLIERS_MANAGE_PERSONAL_DATA.BASIC_IDENTIFICATION]: 'Basic ID',
  [SUPPLIERS_MANAGE_PERSONAL_DATA.FINANCIAL_DATA]: 'Financial',
  [SUPPLIERS_MANAGE_PERSONAL_DATA.HEALTH_DATA]: 'Health',
  [SUPPLIERS_MANAGE_PERSONAL_DATA.SPECIAL_CATEGORIES]: 'Special',
  [SUPPLIERS_MANAGE_PERSONAL_DATA.OTHER]: 'Other',
}
const RISK_LEVEL_LABELS = {
  [SUPPLIER_RISK_CLASSIFICATION.VERY_LOW]: 'Very Low',
  [SUPPLIER_RISK_CLASSIFICATION.LOW]: 'Low',
  [SUPPLIER_RISK_CLASSIFICATION.MEDIUM]: 'Medium',
  [SUPPLIER_RISK_CLASSIFICATION.HIGH]: 'High',
  [SUPPLIER_RISK_CLASSIFICATION.EXTREME]: 'Extreme',
}
const CATEGORY_LABELS = {
  [SUPPLIER_CATEGORIES.CRITICAL]: 'Critical',
  [SUPPLIER_CATEGORIES.NON_CRITICAL]: 'Non-Critical',
}
const STATUS_REVIEWED = 'Reviewed'
const STATUS_PENDING = 'Pending'
export const SUPPLIERS_LIST = {
  HIDE_INTERNAL_APPS: 'Hide internal apps',
  INTERNAL_APP: 'Internal',
  UPLOAD_SUPPLIERS: 'Upload Suppliers',
  DOWNLOAD_TEMPLATE: 'Download Template for Bulk Upload',
  TITLE: 'Suppliers',
  SEARCH_PLACEHOLDER: 'Search suppliers...',
  NAME: 'Name',
  RESPONSIBLE: 'Responsible',
  PERSONAL_DATA: 'Personal Data',
  RISK_LEVEL: 'Risk Level',
  CATEGORY: 'Category',
  DEPARTMENT: 'Department',
  SECURITY_STATUS: 'Security Status',
  REVIEW_STATUS: 'Review Status',
  COMPLIANT: 'Compliant',
  NON_COMPLIANT: 'Non-Compliant',
  REVIEWED: STATUS_REVIEWED,
  PENDING: STATUS_PENDING,
  PERSONAL_DATA_LABELS,
  RISK_LEVEL_LABELS,
  CATEGORY_LABELS,
  SUCCESS_UPLOAD_SUPPLIERS: 'Suppliers uploaded successfully',
  ERROR_UPLOAD_SUPPLIERS: 'Error uploading suppliers',
  UPLOADING_SUPPLIERS: 'Uploading suppliers...',
  BULK_UPLOAD_TITLE: 'Bulk Upload Suppliers',
  BULK_UPLOAD_DESCRIPTION: 'Upload a CSV or Excel file to create multiple suppliers at once.',
  BULK_UPLOAD: 'Bulk Upload',
  EXPORT: 'Export CSV',
  EXPORT_EMPTY: 'There are no suppliers to export yet.',
}

export const SUPPLIERS_DETAILS = {
  TITLE: 'Supplier Details',
  GENERAL_INFORMATION: 'General Information',
  NAME: 'Name',
  WEBSITE: 'Website',
  RESPONSIBLE: 'Responsible',
  DEPARTMENT: 'Department',
  MANAGE_PERSONAL_DATA: 'Manage Personal Data',
  SECURITY_RELATED_INFORMATION: 'Security Information',
  RISK_CLASSIFICATION: 'Risk Level',
  CATEGORY: 'Category',
  SERVICE_TYPE: 'Service Type',
  SAAS: 'SaaS',
  ON_PREMISE: 'On-Premise',
  SAAS_TRUE: 'Yes',
  SAAS_FALSE: 'No',
  RESPONSE_EXPECTATIONS: 'Response Expectations',
  RESPONSE_EXPECTATIONS_TRUE: 'Yes',
  RESPONSE_EXPECTATIONS_FALSE: 'No',
  SECURITY_CERTIFICATION: 'Security Certification',
  SECURITY_CERTIFICATION_TRUE: 'OK',
  SECURITY_CERTIFICATION_FALSE: 'KO',
  SECURITY_COMPLIANCE_STATUS: 'Security Compliance Status',
  SECURITY_COMPLIANCE_STATUS_TRUE: 'Compliant',
  SECURITY_COMPLIANCE_STATUS_FALSE: 'Non-Compliant',
  REVIEW_RELATED_INFORMATION: 'Review Information',
  SUPPLIER_CONTACT_NAME: 'Supplier Contact Name',
  SECURITY_QUESTIONNAIRE: 'Security Questionnaire',
  SECURITY_QUESTIONNAIRE_LINK: 'View Security Questionnaire',
  CONTRACT: 'Contract',
  CONTRACT_LINK: 'View Contract',
  REVIEW_STATUS: 'Review Status',
  DATE_LAST_REVIEW: 'Date Last Review',
  DATE_NEXT_REVIEW: 'Date Next Review',
  FINDINGS_EVALUATION: 'Findings Evaluation',
  NOTES: 'Notes',
  PERSONAL_DATA_LABELS,
  RISK_LEVEL_LABELS,
  CATEGORY_LABELS,
  STATUS_REVIEWED,
  STATUS_PENDING,
  DELETE_DIALOG: {
    TITLE: 'Delete Supplier',
    QUESTION: 'Are you sure you want to delete the supplier ',
    CANCEL: 'Cancel',
    DELETE: 'Delete',
  },
}

export const SUPPLIER_CREATION_DIALOG = {
  CREATE: 'Create Supplier',
}

export const SUPPLIER_FORM = {
  BASIC_INFORMATION: 'Basic Information',
  NAME: 'Name',
  NAME_PLACEHOLDER: 'Supplier name',
  RESPONSIBLE: 'Responsible',
  WEBSITE: 'Website',
  CONTACT_NAME: 'Contact Name',
  CONTACT_NAME_PLACEHOLDER: 'Contact name',
  DATA_MANAGEMENT: 'Data Management',
  MANAGE_PERSONAL_DATA: 'Manage Personal Data',
  SELECT_MANAGE_PERSONAL_DATA: 'Select...',
  CONTRACT_RISK: 'Contract & Risk',
  CONTRACT_URL: 'Contract URL',
  RISK_CLASSIFICATION: 'Risk Classification',
  SELECT_RISK_CLASSIFICATION: 'Select...',
  SERVICE_TYPE: 'Service Type',
  IS_SAAS: 'Is SaaS',
  RESPONSE_EXPECTATIONS: 'Response Expectations',
  SECURITY_COMPLIANCE: 'Security & Compliance',
  CONTRACT_URL_PLACEHOLDER: 'https://example.com/contract',
  SECURITY_CERTIFICATION_URL: 'Security Certification URL',
  SECURITY_CERTIFICATION_URL_PLACEHOLDER: 'https://example.com/security-certification',
  SECURITY_QUESTIONNAIRE_URL: 'Security Questionnaire URL',
  SECURITY_QUESTIONNAIRE_URL_PLACEHOLDER: 'https://example.com/questionnaire',
  REVIEW: 'Review',
  REVIEW_DATE: 'Review Date',
  FINDINGS_EVALUATION: 'Findings Evaluation',
  FINDINGS_STATUS: 'Status OK',
  FINDINGS_NOTES_PLACEHOLDER: 'Notes...',
  SELECT_DATE_PLACEHOLDER: 'Select date',
  NEXT_REVIEW_EMPTY: 'Set last review date',
  SELECT_RISK_LEVEL: 'Select risk level',
  CATEGORY_EMPTY: 'Set category',
  CATEGORY_HELP: 'Set independently from risk level. Critical suppliers are reviewed more frequently.',
  SECURITY_STATUS_HELP: 'Compliant when a security certification or a security questionnaire URL is provided.',
  NEXT_REVIEW_HELP: 'Critical suppliers: +1 year from last review. Non-Critical suppliers: +2 years from last review.',
  REVIEW_STATUS_HELP: 'Pending if next review date is within 30 days or overdue. Reviewed otherwise.',
}

export const SUPPLIER_MESSAGES = {
  CREATING: 'Creating supplier...',
  CREATED: (name: string) => `Supplier ${name} created successfully`,
}
